"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const long_settimeout_1 = require("long-settimeout");
/** A promisified timeout. */
function waitFor(ms = 0) {
    return new Promise((resolve) => long_settimeout_1.setLongTimeout(resolve, ms));
}
exports.default = waitFor;
